// SLICE
import { appTourSlice } from './slice';

// ACTIONS
const { setAppTourComponent, setEnabledAppTour } = appTourSlice.actions;

export { setAppTourComponent, setEnabledAppTour };
